/* eslint-disable no-use-before-define */
import React from 'react'
import { isEmpty, getState, Status, ajax } from '../twd'

const Last = getState('treasury-cart.last', {
    ts: 0,
})
let loading = false

export default () => {

    const [chartData, setChartData_] = React.useState(Last.value.chartData || [])
    const setChartData = React.useCallback((chartData) => {
        Last.set({chartData})
        setChartData_(chartData)
    }, [])

    const [chartDataStatus, setChartDataStatus_] = React.useState(Last.value.chartDataStatus || Status.LOADING)
    const setChartDataStatus = React.useCallback((chartDataStatus) => {
        Last.set({chartDataStatus})
        setChartDataStatus_(chartDataStatus)
    }, [])

    React.useEffect(() => {(async () => {
        if (!isEmpty(chartData) || loading) return

        setChartDataStatus(Status.LOADING)
        loading = true
        
        try {
            let url = '/esb/retailservice/yieldCurveService/getYieldCurveData'
            let { data:data__ } = await ajax({
                url,
                method: 'GET'
            })

            let data_ = (await data__).yieldCurveDataMap || {}
            let data = [
                { id:'BD_1MO', name:'1M', x:0 },
                { id:'BD_3MO', name:'3M', x:1 },
                { id:'BD_6MO', name:'6M', x:2 },
                { id:'BD_1YR', name:'1Y', x:3 },
                { id:'BD_2YR', name:'2Y', x:4 },
                { id:'BD_3YR', name:'3Y', x:5 },
                { id:'BD_5YR', name:'5Y', x:6 },
                { id:'BD_7YR', name:'7Y', x:7 },
                { id:'BD_10YR', name:'10Y', x:8 },
                { id:'BD_20YR', name:'20Y', x:9 },
                { id:'BD_30YR', name:'30Y', x:10 }
            ].map(({id, name, x}) => {
                let a = data_[id] || {}
                return {
                    name,
                    x,
                    current: (a.current || {}).ytw,
                    "1mo": (a.month1 || {}).ytw,
                    "3mo": (a.month3 || {}).ytw,
                    "6mo": (a.month6 || {}).ytw,
                    "1yr": (a.month12 || {}).ytw,
                }
            })

            setChartData(data)
            setChartDataStatus(Status.LOADED)
        } catch(e) {
            setChartDataStatus(Status.FAILED_TO_LOAD)
        }

        loading = false

     })()}, [chartData, setChartData])


     return {
        chartData,
        chartDataStatus,
     }
}


// WEBPACK FOOTER //
// ./src/treasury-chart/use-chart.js